import Model, { attr } from "@ember-data/model";

/**
 * Either component or linkUrl is set.
 */
export default class LearningArticle extends Model {
  @attr("string") declare component: string | undefined;
  @attr() declare followUpReasons: Array<string>;
  @attr("string") declare linkUrl: string | undefined;
  @attr("string") declare title: string | undefined;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "learning-article": LearningArticle;
  }
}
